import type { ArticleDetail } from "./article-content";

export type ArticleSummary = Pick<
  ArticleDetail,
  "slug" | "categoryId" | "title" | "excerpt" | "category" | "readingTime" | "date" | "imageIndex"
>;

export const articleSummaries: ArticleSummary[] = [
  {
    slug: "parkett-oder-vinyl-bodenvergleich-2026",
    categoryId: "boden",
    title: "Parkett oder Vinyl? Der grosse Bodenvergleich 2026",
    excerpt:
      "Pflege, Preis, Wohnklima: Welcher Bodenbelag passt zu welchem Raum, und was kostet er pro m² in der Schweiz?",
    category: "Bodenbeläge",
    readingTime: "6 Min.",
    date: "12. Juni 2026",
    imageIndex: 0,
  },
  {
    slug: "fassadensanierung-kosten-foerderungen-zeitplan",
    categoryId: "fassade",
    title: "Fassadensanierung: Kosten, Förderungen und Zeitplan",
    excerpt:
      "So planen Sie Ihre Fassadensanierung Schritt für Schritt, mit Schweizer Förderprogrammen und Energieeinsparung.",
    category: "Fassade",
    readingTime: "8 Min.",
    date: "04. Juni 2026",
    imageIndex: 1,
  },
  {
    slug: "badumbau-in-6-wochen-realistischer-bauablauf",
    categoryId: "sanitaer",
    title: "Badumbau in 6 Wochen: Realistischer Bauablauf",
    excerpt:
      "Vom Rückbau bis zur Endreinigung, ein typischer Zeitplan, Stolperfallen und Tipps zur Kommunikation mit dem Handwerker.",
    category: "Sanitär",
    readingTime: "5 Min.",
    date: "28. Mai 2026",
    imageIndex: 2,
  },
  {
    slug: "waermepumpe-statt-oelheizung-lohnt-sich-wechsel",
    categoryId: "haustechnik",
    title: "Wärmepumpe statt Ölheizung: Lohnt sich der Wechsel?",
    excerpt:
      "Investitionskosten, laufende Kosten und CO₂-Einsparung im Vergleich, inkl. Beispielrechnung für ein Einfamilienhaus.",
    category: "Haustechnik",
    readingTime: "7 Min.",
    date: "19. Mai 2026",
    imageIndex: 3,
  },
  {
    slug: "kostenfalle-umbau-7-haeufige-fehler",
    categoryId: "ratgeber",
    title: "Kostenfalle Umbau: Die 7 häufigsten Fehler",
    excerpt:
      "Vom unterschätzten Rückbau bis zur falschen Offertenstruktur, worauf Bauherren in der Schweiz besonders achten sollten.",
    category: "Ratgeber",
    readingTime: "9 Min.",
    date: "10. Mai 2026",
    imageIndex: 4,
  },
  {
    slug: "schweizer-holzbau-trends-bauzeit",
    categoryId: "neubau",
    title: "Schweizer Holzbau: Trends und Bauzeit im Überblick",
    excerpt:
      "Warum sich modulare Holzbauten lohnen, welche Hersteller relevant sind, und wie lange ein Holzhaus heute wirklich dauert.",
    category: "Neubau",
    readingTime: "6 Min.",
    date: "02. Mai 2026",
    imageIndex: 5,
  },
  {
    slug: "umzugsreinigung-mit-abnahmegarantie",
    categoryId: "reinigung",
    title: "Umzugsreinigung mit Abnahmegarantie: worauf Sie achten sollten",
    excerpt:
      "Checkliste für Offerten, Schlüsselübergabe und typische Zusatzkosten bei der Endreinigung in der Schweiz.",
    category: "Reinigung",
    readingTime: "5 Min.",
    date: "24. April 2026",
    imageIndex: 6,
  },
  {
    slug: "umzug-planen-kosten-timing-zuegelfirma",
    categoryId: "umzug",
    title: "Umzug planen: Kosten, Timing und die richtige Zügelfirma",
    excerpt:
      "So vergleichen Sie Umzugsofferten fair und vermeiden Lücken bei Verpackung, Transport und Möbelmontage.",
    category: "Umzug",
    readingTime: "6 Min.",
    date: "18. April 2026",
    imageIndex: 7,
  },
  {
    slug: "elektriker-beauftragen-wann-profi-noetig-ist",
    categoryId: "haustechnik",
    title: "Elektriker beauftragen: wann ein Profi zwingend nötig ist",
    excerpt:
      "Von Steckdosen bis Wallbox: welche Elektroarbeiten Sie planen lassen sollten und welche Nachweise wichtig sind.",
    category: "Haustechnik",
    readingTime: "4 Min.",
    date: "11. April 2026",
    imageIndex: 8,
  },
  {
    slug: "eigenmietwert-berechnen-rechner-schweiz",
    categoryId: "ratgeber",
    title: "Eigenmietwert verstehen und berechnen: mit Rechner für Ihr Eigenheim",
    excerpt:
      "Was Ihr Eigenheim zum steuerbaren Einkommen beiträgt, wie Zinsen und Unterhalt wirken und was sich ab 2029 ändert. Mit interaktivem Rechner.",
    category: "Ratgeber",
    readingTime: "6 Min.",
    date: "1. Oktober 2026",
    imageIndex: 1,
  },
];

export function requireArticleSummary(slug: string): ArticleSummary {
  const summary = articleSummaries.find((article) => article.slug === slug);
  if (!summary) throw new Error(`Missing article summary: ${slug}`);
  return summary;
}
